module.exports = __webpack_public_path__ + "img/mobile-default.044bf46c.png";